import React from 'react';
import { useIntl } from 'react-intl';

import { SfaFatalError } from '@futrli/shared-services';

import image from './images/request-approval.svg';

export const SfaUserCannotCreateNewOrgFatalError = () => {
  const intl = useIntl();

  const text = {
    title: intl.formatMessage({
      id: 'onboarding.sfa.we_could_not_create_this_organisation',
      defaultMessage: 'We could not create this organisation'
    }),
    subtitle: intl.formatMessage({
      id: 'onboarding.sfa.you_do_not_have_permissions_to_create_new_org',
      defaultMessage: 'You do not have the permissions you need to create a new organisation.'
    }),
    text1: intl.formatMessage({
      id: 'onboarding.sfa.you_must_be_admin_user_to_create_new_org',
      defaultMessage: 'You must be an Administrator or Super administrator user to create a new organisation.'
    }),
    text2: intl.formatMessage({
      id: 'onboarding.sfa.contact_your_futrli_admin',
      defaultMessage:
        'Contact your workspace administrator to ensure you have the permissions you need before you try again.'
    })
  };

  const textBlock = (
    <>
      {text.text1}
      <br />
      <br />
      {text.text2}
    </>
  );

  return <SfaFatalError image={image} {...text} text={textBlock} />;
};
